import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type UpdateSnilsOperation = paths['/executor_web/identification/snils']['patch'];

export type UpdateSnilsRequest = NonNullable<
	NonNullable<UpdateSnilsOperation['requestBody']>['content']['application/json']
>;
export type UpdateSnilsResponse = UpdateSnilsOperation['responses'][200]['content']['application/json'];
export type UpdateSnilsErrorResponse = UpdateSnilsOperation['responses'][400]['content']['application/json'];

/** PATCH `/executor_web/identification/snils` — см. `paths['/executor_web/identification/snils']` в auth swagger */
export function updateSnils(request: UpdateSnilsRequest, signal?: AbortSignal) {
	return axiosInstance.patch<UpdateSnilsResponse>('identification/snils', request, {signal});
}
